import { render, staticRenderFns } from "./ReportBagTabIndex.vue?vue&type=template&id=ea73e3d8&scoped=true"
import script from "./ReportBagTabIndex.vue?vue&type=script&lang=js"
export * from "./ReportBagTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea73e3d8",
  null
  
)

export default component.exports